// ** Reducers Imports
/* eslint-disable */
import layout from "./layout"
import navbar from "./navbar"
import authSlice from "./authSlice"
import { combineReducers } from "@reduxjs/toolkit";
import employeeReducer from "./employeeSlice";
import customerReducer from './customerSlice'
import bookingsReducer from './bookingSlice'
import pricingReducer from './pricingSlice'
import opsManagerReducer from './opsManagerSlice'
import socketReducer from "./socketSlice";
const rootReducer = combineReducers({
  user: authSlice,
  navbar: navbar,
  layout: layout,
  employee: employeeReducer,
  customers: customerReducer,
   bookings: bookingsReducer,
   pricing: pricingReducer,
  opsManager: opsManagerReducer,
  socket: socketReducer,
});

//const rootReducer = { navbar, layout, authSlice };

export default rootReducer
